import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";

import { CommonApi } from "../../api/common.api";

import { InterfaceStaticService } from "../../static-services/interface.static-service";
import { GlobalStaticService } from "../../static-services/global.static-service";

import { Policy } from "../../models/policy";
import { Quote } from "../../models/quote";
import { ActivatedRoute, Params } from "@angular/router";
import { CommonUtility } from "../../utilities/common.utility";

@Component({
    selector: "app-policies-page-component",
    templateUrl: "./policies.page.html",
    styleUrls: ["./policies.page.scss"]
})
export class PoliciesPageComponent implements OnInit {
    GlobalStaticSrv = GlobalStaticService;
    CommonUtil = CommonUtility;
    policies: Policy[] = [];
    searchString = "";
    searchActive = false;
    resultActive = false;
    timeout: any;
    timeoutFlag = false;
    @ViewChild("main") main: ElementRef;
    @ViewChild("claimPage") claimPage: ElementRef;
    @ViewChild("clientPage") clientPage: ElementRef;
    @ViewChild("policyPage") policyPage: ElementRef;
    @ViewChild("createCocPage") createCocPage: ElementRef;
    @ViewChild("quotePage") quotePage: ElementRef;
    histories: any[] = [{ page: "main" }];
    viewClaimId: string;
    viewClientId: string;
    viewPolicyId: string;
    viewPolicy: Policy;
    viewQuoteId: string;
    quote: Quote = new Quote();
    requesting$$: any;
    @ViewChild("policyComponent") policyComponent;
    @ViewChild("clientComponent") clientComponent;
    @ViewChild("claimComponent") claimComponent;
    @ViewChild("quoteComponent") quoteComponent;
    switching = false;
    path: string;
    constructor(private commonApi: CommonApi, private route: ActivatedRoute) { }
    ngOnInit(): void {
        this.path = this.route.snapshot.url[0].path;
        //this.commonApi.postEndConversation();
    }
    setPolicy(event: any): void {
        this.viewPolicy = event;
    }
    setQuote(event: any): void {
        this.quote = event;
    }
    back(): void {
        if (this.histories.length > 1 && !this.switching) {
            this.switching = true;
            setTimeout(() => {
                this.switching = false;
            }, 500);
            switch (this.histories[this.histories.length - 1].page) {
                case "claimPage":
                    this.claimComponent.back();
                    break;
                case "clientPage":
                    this.clientComponent.back();
                    break;
                case "policyPage":
                    this.policyComponent.back();
                    break;
                case "quotePage":
                    this.quoteComponent.back();
                    break;
            }
        }
    }
    searchChange(): void {
        if (this.searchString && this.searchString.length >= 3) {
            this.searchActive = true;
            this.search();
        } else {
            this.searchActive = false;
        }
    }
    search(): void {
        if (this.searchString) {
            this.resultActive = true;
            if (this.requesting$$) {
                this.requesting$$.unsubscribe();
            }
            this.requesting$$ = this.commonApi
                .getPolicies(this.searchString, this.path)
                .subscribe(res => {
                    this.policies = res;
                    this.resultActive = false;
                });
        }
    }
    get getValidPolicyNo(): number {
        let valid = 0;
        for (let i = 0; i < GlobalStaticService.recentPolicies.length; i++) {
            if (
                GlobalStaticService.recentPolicies[i].policyStatusText ===
                "Bound" &&
                !CommonUtility.isDateBeforeToday(
                    CommonUtility.getDateObjectBasedOnTFormat(
                        GlobalStaticService.recentPolicies[i].termExpiryDate
                    )
                )
            ) {
                valid++;
            }
        }
        return valid;
    }
    clean(): void {
        this.searchActive = false;
        this.resultActive = false;
        this.policies = [];
    }
    fullClean(): void {
        this.searchString = "";
        this.clean();
    }
    searchBlur(): void {
        this.timeoutFlag = true;
        this.timeout = setTimeout(() => {
            this.clean();
        }, 200);
    }
    searchClick(): void {
        if (this.searchString) {
            if (this.timeoutFlag) {
                clearTimeout(this.timeout);
                this.timeoutFlag = false;
            }
            if (!this.searchActive) {
                this.search();
            }
            this.searchActive = !this.searchActive;
            if (!this.searchActive) {
                this.resultActive = false;
                this.policies = [];
            }
        } else {
            this.policies = GlobalStaticService.recentPolicies;
            this.searchActive = true;
        }
    }
    gotoPolicy(policy: Policy): void {
        this.searchString = "";
        this.searchBlur();
        this.gotoPage({
            currentPage: "main",
            nextPage: "policyPage",
            nextId: policy.policyId
        });
    }
    setViewId(page: string, id: any): void {
        switch (page) {
            case "claimPage":
                this.viewClaimId = id;
                break;
            case "clientPage":
                this.viewClientId = id;
                break;
            case "policyPage":
                this.viewPolicyId = id;
                break;
            case "quotePage":
                this.viewQuoteId = id;
                break;
            case "createCocPage":
                this.viewPolicy = id;
                break;
        }
    }
    cleanViewId(page: string): void {
        switch (page) {
            case "claimPage":
                this.viewClaimId = null;
                break;
            case "clientPage":
                this.viewClientId = null;
                break;
            case "policyPage":
                this.viewPolicyId = null;
                break;
            case "quotePage":
                this.viewQuoteId = null;
                break;
            case "createCocPage":
                this.viewPolicy = null;
                break;
        }
    }
    cleanClassList(page: string): void {
        this[page].nativeElement.classList.remove("slideInLeft");
        this[page].nativeElement.classList.remove("slideInRight");
        this[page].nativeElement.classList.remove("slideOutLeft");
        this[page].nativeElement.classList.remove("slideOutRight");
    }
    gotoPage(event: any): void {
        this.setViewId(event.nextPage, event.nextId);

        this.cleanClassList(event.currentPage);
        this.cleanClassList(event.nextPage);
        this[event.currentPage].nativeElement.classList.add("slideOutLeft");
        this[event.nextPage].nativeElement.classList.add("slideInRight");
        setTimeout(() => {
            this[event.nextPage].nativeElement.classList.add("active");
        });
        setTimeout(() => {
            this[event.currentPage].nativeElement.classList.remove("active");
            this.cleanViewId(event.currentPage);
        }, 500);
        if (event.currentPage === "main") {
            InterfaceStaticService.noFooter = true;
        }

        this.histories.push({
            page: event.nextPage,
            id: event.nextId
        });
    }
    backtoPage(event: any): void {
        const previous = this.histories[this.histories.length - 2];
        const current = this.histories[this.histories.length - 1];
        this.setViewId(previous.page, previous.id);

        this.cleanClassList(previous.page);
        this.cleanClassList(current.page);
        this[previous.page].nativeElement.classList.add("slideInLeft");
        this[current.page].nativeElement.classList.add("slideOutRight");
        setTimeout(() => {
            this[previous.page].nativeElement.classList.add("active");
        });
        setTimeout(() => {
            this[current.page].nativeElement.classList.remove("active");
            this.cleanViewId(current.page);
            this.histories.splice(this.histories.length - 1, 1);
        }, 500);
        if (previous.page === "main") {
            InterfaceStaticService.noFooter = false;
        }
    }
    bindEventEmitter(event: boolean): void {
        if (event) {
            GlobalStaticService.isQuoteBind = true;
        }
    }
}
